module.exports = __webpack_public_path__ + "static/media/docsIcon.e6490986.svg";